import { inject, ref } from '@vue/composition-api';
import { CustomEvent, ElementData } from '../types';
// import { ErrorCode, WorkFlowError } from '../utils'
import { EdgeId, EdgeRef } from '../context';
import { useWorkFlow } from './useWorkFlow';

/**
 * Composable that provides access to an edge object and it's dom element
 *
 * If no edge id is provided, the edge id is injected from context
 *
 * If you do not provide an id, this composable has to be called in a child of your custom edge component, or it will throw
 *
 * @public
 * @param id - The id of the edge to access
 * @returns the edge id, the edge and the edge dom element
 */
export function useEdge<
  Data = ElementData,
  CustomEvents extends Record<string, CustomEvent> = any
>(id?: string) {
  const edgeId = id ?? inject(EdgeId, '');
  const edgeEl = inject(EdgeRef, ref(null));

  const { findEdge, emits } = useWorkFlow();

  const edge = findEdge<Data, CustomEvents>(edgeId)!;

  if (!edge) {
    // emits.error(new WorkFlowError(ErrorCode.EDGE_NOT_FOUND, edgeId))
  }

  return {
    id: edgeId,
    edge,
    edgeEl
  };
}
